import { getOnlyDate } from '~/astra'
import { assertUnreachable } from '~/utils/utils'

import { AvailabilityPeriod } from '../../Drawer/PatientDrawerTab/StatusesAndRemarks/PatientAvailability/utils'
import { TrackingSuggestionDataAvailabilityPeriod } from './tracking'

type NonWaitingAvailabilityPeriod = Exclude<TrackingSuggestionDataAvailabilityPeriod, { type: 'waiting' }>

export function getAvailabilityPeriods(availabilities: AvailabilityPeriod[]): NonWaitingAvailabilityPeriod[] {
    return availabilities.map(availability => {
        switch (availability.type) {
            case 'availableFrom':
                return {
                    type: 'available_from',
                    start_date: getOnlyDate(availability.startDate),
                }
            case 'unavailableBetween':
                return {
                    type: 'unavailable_between',
                    start_date: getOnlyDate(availability.startDate),
                    end_date: getOnlyDate(availability.endDate),
                }
            default:
                throw assertUnreachable(availability, (availability as { type: string }).type)
        }
    })
}

// "Extended" here means availability periods + isWaiting
export function getExtendedAvailabilityPeriods(
    availabilities: AvailabilityPeriod[],
    isWaiting: boolean | undefined
): TrackingSuggestionDataAvailabilityPeriod[] {
    const availabilityPeriods = getAvailabilityPeriods(availabilities)
    if (isWaiting) {
        return [{ type: 'waiting' }, ...availabilityPeriods]
    }
    return availabilityPeriods
}
